import { render, staticRenderFns } from "./FacetFilter.vue?vue&type=template&id=68ac2341&"
import script from "./FacetFilter.vue?vue&type=script&lang=js&"
export * from "./FacetFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FacetFilter.vue"
export default component.exports